<template>
  <v-container grid-list-md text-center>
    <v-alert type="error" v-model="token_not_set">
      Token is not configured in ALeRCE TOM. For more information go to
      {{ tom_url }}.
    </v-alert>
    <v-toolbar dense dark elevation="0">
      <v-toolbar-title>
        <v-icon>mdi-telescope</v-icon> TOM Candidates</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn
        tile
        depressed
        class="ma-2 text-capitalize"
        color="grey darken-3"
        @click="downloadCSV()"
      >
        <v-icon left>mdi-download</v-icon> Download CSV
      </v-btn>
    </v-toolbar>
    <v-card outlined>
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="caption"
          >Currently {{ totalReports }} good candidates reported in
          {{ getLastDays(selected_days) }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search by object id"
            single-line
            hide-details
            class="mr-6 ml-6"
          ></v-text-field>

          <v-select :items="filter_days" v-model="selected_days"></v-select>
        </v-toolbar-items>
      </v-toolbar>

      <v-data-table
        :dense="true"
        :headers="headers"
        :items="reports"
        :options.sync="tableOptions"
        :server-items-length="totalReports"
        :loading="loading"
      >
        <template v-slot:[`item.object`]="{ item }">
          <div v-html="urlObject(item.object)"></div>
        </template>

        <template v-slot:[`item.first_date`]="{ item }">
          <div>{{ item.first_date.toUTCString() }}</div>
        </template>

        <template v-slot:[`item.last_date`]="{ item }">
          <div>{{ item.last_date.toUTCString() }}</div>
        </template>

        <template v-slot:[`item.first_detection`]="{ item }">
          <div>
            {{ item.first_detection ? item.first_detection.toUTCString() : "" }}
          </div>
        </template>

        <template v-slot:[`item.last_detection`]="{ item }">
          <div>
            {{ item.last_detection ? item.last_detection.toUTCString() : "" }}
          </div>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <span v-if="loading_action">
            <v-progress-circular
              indeterminate
              color="primary"
              :width="3"
              :size="10"
            ></v-progress-circular>
          </span>
          <span v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="ma-0"
                  icon
                  color="green"
                  @click="openDetails(item)"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Details</span>
            </v-tooltip>

            <v-tooltip v-if="!item.target_id" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  color="blue"
                  @click="createTarget(item.object)"
                >
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </template>
              <span>Create Target</span>
            </v-tooltip>

            <span v-else-if="item.target_id != -1">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    text
                    icon
                    color="green"
                    :href="getTomUrl(item.target_id)"
                    target="_blank"
                  >
                    <v-icon>mdi-desktop-mac</v-icon>
                  </v-btn>
                </template>
                <span>Check in TOM</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    text
                    icon
                    color="red"
                    @click="openDelete(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Delete Target</span>
              </v-tooltip>
            </span>
          </span>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="delete_dialog" max-width="700">
      <delete-target
        :candidate.sync="selected"
        :show.sync="delete_dialog"
      ></delete-target>
    </v-dialog>
    <v-dialog v-model="details_dialog">
      <report-detail
        :candidate="selected"
        :show.sync="details_dialog"
      ></report-detail>
    </v-dialog>
  </v-container>
</template>
<script>
import DeleteTarget from "@/components/dialogs/DeleteTarget.vue";
import ReportDetail from "@/components/dialogs/ReportDetail.vue";
// import { debounce } from "../components/utils/report.js";
import lodash from "lodash";
export default {
  name: "TOMCandidates",
  data() {
    return {
      headers: [
        { value: "object", text: "Candidate" },
        { value: "nobs", text: "# detections", align: "center" },
        { value: "first_detection", text: "Date of first detection" },
        { value: "last_detection", text: "Date of last detection" },
        { value: "count", text: "Reports", align: "center" },
        { value: "source", text: "Source(s)" },
        { value: "first_date", text: "First date reported" },
        { value: "last_date", text: "Last date reported" },
        { value: "action", text: "Action", align: "center" }
      ],
      dialog: false,
      seeDetails: false,
      selected: null,
      search: "",
      reports: [],
      loading: false,
      totalReports: 0,
      tableOptions: {},
      filter_days: [
        { text: "Last 24 hours", value: 1 },
        { text: "Last 48 hours", value: 2 },
        { text: "Last 72 hours", value: 3 },
        { text: "Last week", value: 7 },
        { text: "Last month", value: 30 }
      ],
      selected_days: 1,
      disable_download: false,
      token_not_set: false,
      loading_action: false,
      delete_dialog: false,
      details_dialog: false,
      tom_url: process.env.VUE_APP_TOM_API
    };
  },
  components: {
    DeleteTarget,
    ReportDetail
  },
  methods: {
    getTomUrl(id) {
      return process.env.VUE_APP_TOM_API + "/targets/" + id + "/";
    },
    createTarget(oid) {
      this.loading_action = true;
      this.$ztfapi
        .get_stats(oid)
        .then(response => {
          let ra = response.data.meanra;
          let dec = response.data.meandec;
          let oid = response.data.oid;
          this.$tomapi
            .create_target(oid, ra, dec)
            .then(response => {
              this.reports = this.reports.map(x => {
                if (x.object == response.data.name) {
                  x.target_id = response.data.id;
                }
                return x;
              });
            })
            .catch(function() {});
        })
        .catch(function() {});
      this.loading_action = false;
    },
    downloadCSVfromjson() {
      let arrayOfJson = this.reports.map(x => {
        var y = {};
        y.object = x.object;
        y.nobs = x.nobs;
        y.first_detection = x.first_detection;
        y.last_detection = x.last_detection;
        y.count = x.count;
        y.report_type = x.report_type;
        y.first_date = x.first_date;
        y.last_date = x.last_date;
        y.source = x.source;
        y.alerce_link = `https://alerce.online/object/${x.object}`;
        return y;
      });
      const replacer = (key, value) => (value == null ? "" : `${value}`); // specify how you want to handle null values here
      const header = Object.keys(arrayOfJson[0]);
      let csv = arrayOfJson.map(row =>
        header
          .map(fieldName => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(header.join(","));
      csv = csv.join("\r\n").replace(/"/g, "");
      // Create link and download
      var link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(csv)
      );
      var today = new Date();
      var str_date = today
        .toISOString()
        .split("T")[0]
        .split("-")
        .join("");
      let filename = "Candidates_" + str_date + ".csv";
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadCSV() {
      let this_store = this;
      this.$api.getCSV("TOM", this.selected_days).then(function(response) {
        var today = new Date();
        var str_date = today
          .toISOString()
          .split("T")[0]
          .split("-")
          .join("");
        let fileName = "Candidates_" + str_date + ".csv";
        this_store.disable_download = true;
        let file = new Blob([response.data], { type: "text/csv" });
        let filename = fileName;
        if (window.navigator.msSaveOrOpenBlob)
          // IE10+
          window.navigator.msSaveOrOpenBlob(file, filename);
        else {
          // Others
          let a = document.createElement("a"),
            url = URL.createObjectURL(file);
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
        this_store.disable_download = false;
      });
    },
    getData: lodash.debounce(function(page, size, days, objectId = null) {
      this.loading = true;
      this.targets = [];

      let date = new Date();
      date.setDate(date.getDate() - days);
      this.$api
        .getReportsByObject(
          page,
          size,
          "TOM",
          date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate(),
          objectId
        )
        .then(response => {
          this.totalReports = response.data.count;
          let reports = this.formatReports(response.data.results);
          this.$tomapi
            .get_recent_targets(days)
            .then(response => {
              if (!response.data) {
                return;
              }
              this.reports = reports.map(x => {
                let target_id = response.data.find(y => {
                  return y.name == x.object;
                });
                if (target_id) {
                  x.target_id = target_id.id;
                } else {
                  x.target_id = null;
                }
                return x;
              });
            })
            .catch(() => {
              this.reports = reports.map(x => {
                x.target_id = -1;
                return x;
              });
              this.token_not_set = true;
            });
          this.loading = false;
        });
    }, 500),
    getStats(oid) {
      return this.$ztfapi
        .get_stats(oid)
        .then(response => {
          return response.data;
        })
        .catch(() => {
          return " - ";
        });
    },
    formatReports(arr) {
      return arr.map(x => {
        x.first_detection = null;
        x.first_date = new Date(x.first_date);
        x.last_date = new Date(x.last_date);
        return x;
      });
    },
    urlObject(candidate) {
      return `<a href="https://alerce.online/object/${candidate}" target="_blank">${candidate}</a>`;
    },
    openDelete(item) {
      this.selected = item;
      this.delete_dialog = true;
    },
    openDetails(item) {
      this.selected = item;
      this.details_dialog = true;
    },
    getLastDays(days) {
      return this.filter_days.find(x => x.value == days).text.toLowerCase();
    },
    jdToDate(mjd) {
      if (mjd == undefined || mjd == null || mjd === "") return null;
      var date = (mjd - 40587) * 86400000;
      return new Date(date);
    }
  },
  watch: {
    selected_days(newVal) {
      this.getData(
        this.tableOptions.page,
        this.tableOptions.itemsPerPage,
        newVal
      );
    },
    selected() {
      if (!this.details_dialog)
        this.getData(1, this.tableOptions.itemsPerPage, this.selected_days);
    },
    tableOptions: {
      handler(newOptions) {
        this.getData(
          newOptions.page,
          newOptions.itemsPerPage,
          this.selected_days
        );
      },
      deep: true
    },
    reports(newVal) {
      if (newVal.length != 0) {
        newVal.map(x => {
          this.getStats(x.object).then(stats => {
            x.stats = stats;
            x.first_detection = this.jdToDate(stats.firstmjd);
            x.last_detection = this.jdToDate(stats.lastmjd);
            x.nobs = stats.ndet;
          });
        });
      }
    },
    search(newVal) {
      this.getData(
        this.tableOptions.page,
        this.tableOptions.itemsPerPage,
        this.selected_days,
        newVal
      );
    }
  },
  computed: {
    download_button() {
      var arr = this.reports.map(x => x.first_detection != null);
      if (arr.length == 0) return false;
      return arr.every(x => x);
    }
  }
};
</script>
